module.exports = __webpack_public_path__ + "overlook-studios/img/demo_stasis_v0.gif";